function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

module.exports = function (input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof input === 'string') input = JSON.parse(input);
  var vars = input.head.vars;
  var results = input.results.bindings;

  if (vars.length === 1 && options.minimize === true) {
    var varName = vars[0];
    return results.map(function (result) {
      return parseValue(result[varName]);
    }) // filtering-out bnodes
    .filter(function (result) {
      return result != null;
    });
  }

  var _identifyVars = identifyVars(vars),
      richVars = _identifyVars.richVars,
      associatedVars = _identifyVars.associatedVars,
      standaloneVars = _identifyVars.standaloneVars;

  return results.map(getSimplifiedResult(richVars, associatedVars, standaloneVars));
};

var parseValue = function parseValue(valueObj) {
  if (!valueObj) return;
  var datatype = valueObj.datatype;
  datatype = datatype && datatype.replace('http://www.w3.org/2001/XMLSchema#', '');
  var parser = parsers[valueObj.type] || getDatatypesParsers(datatype);
  return parser(valueObj);
};

var parsers = {
  uri: function uri(valueObj) {
    return parseUri(valueObj.value);
  },
  // blank nodes will be filtered-out in order to get things simple
  bnode: function bnode() {
    return null;
  }
};

var numberParser = function numberParser(valueObj) {
  return parseFloat(valueObj.value);
};

var getDatatypesParsers = function getDatatypesParsers(datatype) {
  datatype = datatype && datatype.replace('http://www.w3.org/2001/XMLSchema#', '');
  return datatypesParsers[datatype] || passValue;
};

var datatypesParsers = {
  decimal: numberParser,
  integer: numberParser,
  float: numberParser,
  double: numberParser,
  boolean: function boolean(valueObj) {
    return valueObj.value === 'true';
  }
}; // return the raw value if the datatype is missing

var passValue = function passValue(valueObj) {
  return valueObj.value;
};

var parseUri = function parseUri(uri) {
  // ex: http://www.wikidata.org/entity/statement/
  if (uri.match(/http.*\/entity\/statement\//)) {
    return convertStatementUriToGuid(uri);
  }

  return uri // ex: http://www.wikidata.org/entity/
  .replace(/^https?:\/\/.*\/entity\//, '') // ex: http://www.wikidata.org/prop/direct/
  .replace(/^https?:\/\/.*\/prop\/direct\//, '');
};

var convertStatementUriToGuid = function convertStatementUriToGuid(uri) {
  // ex: http://www.wikidata.org/entity/statement/
  uri = uri.replace(/^https?:\/\/.*\/entity\/statement\//, '');
  var parts = uri.split('-');
  return parts[0] + '$' + parts.slice(1).join('-');
};

var identifyVars = function identifyVars(vars) {
  var richVars = vars.filter(function (varName) {
    return vars.some(isAssociatedVar(varName));
  });
  var associatedVarPattern = new RegExp("^(".concat(richVars.join('|'), ")[A-Z]"));
  var associatedVars = vars.filter(function (varName) {
    return associatedVarPattern.test(varName);
  });
  var standaloneVars = vars.filter(function (varName) {
    return !richVars.includes(varName) && !associatedVarPattern.test(varName);
  });
  return {
    richVars: richVars,
    associatedVars: associatedVars,
    standaloneVars: standaloneVars
  };
};

var isAssociatedVar = function isAssociatedVar(varNameA) {
  var pattern = new RegExp("^".concat(varNameA, "[A-Z]\\w+"));
  return pattern.test.bind(pattern);
};

var getSimplifiedResult = function getSimplifiedResult(richVars, associatedVars, standaloneVars) {
  return function (result) {
    var simplifiedResult = {};

    var _iterator = _createForOfIteratorHelper(richVars),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var varName = _step.value;
        var richVarData = {};
        var value = parseValue(result[varName]);
        if (value != null) richVarData.value = value;

        var _iterator3 = _createForOfIteratorHelper(associatedVars),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var associatedVarName = _step3.value;
            if (associatedVarName.startsWith(varName)) addAssociatedValue(result, varName, associatedVarName, richVarData);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        if (Object.keys(richVarData).length > 0) simplifiedResult[varName] = richVarData;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(standaloneVars),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _varName = _step2.value;
        simplifiedResult[_varName] = parseValue(result[_varName]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return simplifiedResult;
  };
};

var addAssociatedValue = function addAssociatedValue(result, varName, associatedVarName, richVarData) {
  // ex: propertyType => Type
  var shortAssociatedVarName = associatedVarName.split(varName)[1]; // ex: Type => type

  shortAssociatedVarName = shortAssociatedVarName[0].toLowerCase() + shortAssociatedVarName.slice(1); // ex: altLabel => aliases

  shortAssociatedVarName = specialNames[shortAssociatedVarName] || shortAssociatedVarName;
  var associatedVarData = result[associatedVarName];
  if (associatedVarData != null) richVarData[shortAssociatedVarName] = associatedVarData.value;
};

var specialNames = {
  altLabel: 'aliases'
};